import { render } from "./AdminSystemView.vue?vue&type=template&id=31e714e4&scoped=true&ts=true"
import script from "./AdminSystemView.vue?vue&type=script&lang=ts"
export * from "./AdminSystemView.vue?vue&type=script&lang=ts"

import "./AdminSystemView.vue?vue&type=style&index=0&id=31e714e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e714e4"]])

export default __exports__